import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
var __default__ = {
  name: "DashboardView",
  filters: {
    trim: function trim(value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    }
  },
  data: function data() {
    return {
      isLoading: {
        attendance: true,
        message: true,
        enquete: true
      },
      pollingCount: 0,
      showModal: false,
      pageTitle: "",
      attendances: [],
      absentList3: [],
      absentList20: [],
      absentList30: [],
      date: "",
      enquetes: [],
      messages: [],
      currentDt: "",
      intervalId: undefined,
      logs: [],
      isGradeTables: false,
      attendanceDetailsTableData: [],
      todayAttendance: []
    };
  },
  head: {
    title: function title() {
      return {
        inner: "ダッシュボード"
      };
    },
    meta: []
  },
  computed: _objectSpread(_objectSpread({}, mapState(["school", "studentAddress", "news", "showElevatingNotice"])), {}, {
    loginLogs: function loginLogs() {
      return this.logs.filter(function (v) {
        return v.type === "s";
      }).slice(0, 5);
    }
  }),
  created: function created() {
    var _this = this;

    this.setData();
    this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分"); // 毎分更新

    this.intervalId = setInterval(function () {
      // 時計更新
      _this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分"); // 3時間(180分)ごとに累積欠席者数を取得

      _this.pollingCount++;

      _this.getAttendance(_this.pollingCount % 180 === 0);

      _this.getLogs();
    }, 1000 * 60);
  },
  mounted: function mounted() {
    if (this.me.role_id <= 11 && !this.showElevatingNotice && this.school.elevating && this.school.elevating.date) {
      var firstDateOfMarch = moment().startOf("year").add(2, "month");
      var firstDateOfApril = moment().startOf("year").add(3, "month");

      if (moment().isAfter(firstDateOfMarch) && moment().isBefore(firstDateOfApril)) {
        var message = "生徒名簿・出席簿のダウンロードはお済みですか？" + this.school.elevating.date + "までに対応が必要です。";
        this.$store.dispatch("commitModalMessage", {
          message: message,
          title: ""
        });
        this.$store.dispatch("commitShowElevatingNotice", true);
        this.showModal = true;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    toggleDashboard: function toggleDashboard(showTable) {
      this.isGradeTables = showTable;
    },
    getLogs: function getLogs() {
      var _this2 = this;

      return getData("logs?limit=10&orderby=datetime&order=desc").then(function (data) {
        _this2.logs = data.items.map(function (v) {
          v.fromNow = moment(v.datetime).fromNow();
          return v;
        });
      });
    },
    setData: function setData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.date = moment().format("YYYY/MM/DD");
                _context.next = 3;
                return _this3.getAttendance(true);

              case 3:
                _this3.isLoading.attendance = false;

                _this3.getLogs();

                _context.next = 7;
                return getData(["enquetes/latest", "messages/latest"]).finally(function () {
                  _this3.isLoading.enquete = false;
                  _this3.isLoading.message = false;
                });

              case 7:
                data = _context.sent;
                _this3.enquetes = data[0].items.map(function (v) {
                  return {
                    id: v.id,
                    subject: v.subject,
                    implement_to: moment(v.implement_to).format("YYYY年MM月DD日"),
                    teacher_name: v.teacher_name,
                    visibility: v.visibility,
                    is_visible: v.is_visible
                  };
                });
                _this3.messages = data[1].items.map(function (v) {
                  return {
                    id: v.id,
                    subject: v.subject,
                    send_at: moment(v.message_scheduled_for).format("YYYY年MM月DD日"),
                    teacher_name: v.teacher_name,
                    attached_file: v.attached_file,
                    visibility: v.visibility,
                    is_visible: v.is_visible
                  };
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getAttendance: function getAttendance(calcBadge) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var a, data, attendances, today;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!calcBadge) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return getAbsentAlert();

              case 3:
                a = _context2.sent;
                _this4.absentList3 = a.absentList3;
                _this4.absentList20 = a.absentList20;
                _this4.absentList30 = a.absentList30;

              case 7:
                _context2.next = 9;
                return getData("attendances?limit=300&with=student.classroom&from=" + moment().format("YYYY-MM-DD") + "&with_book_label=1&show_daily_all=1&orderby=updated_at&order=DESC");

              case 9:
                data = _context2.sent;
                attendances = data.items;
                _this4.attendances = attendances.map(function (a) {
                  a.absents = assignAbsentBudge(a.student, _this4.absentList3, _this4.absentList20, _this4.absentList30);
                  a.date = moment(a.date).format("YYYY年MM月DD日");
                  a.created_at = moment(a.created_at).format("MM月DD日 HH時mm分");
                  a.classroom_name = a.student && a.student.classroom ? a.student.classroom.name : null;
                  a.typeText = Text.attendances.type[a.type];
                  a.isHistory = Boolean(!a.is_daily_latest && attendances.filter(function (v) {
                    return v.student_id === a.student_id && v.to_date === a.to_date;
                  }).length > 1);
                  return a;
                }); //大規模校向けテーブルのデータを生成のため今日分のデータを抽出する

                today = moment().format("YYYY年MM月DD日");
                _this4.todayAttendance = _this4.attendances.filter(function (v) {
                  return v.date === today && v.is_daily_latest;
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    navigateToElevate: function navigateToElevate() {
      this.showModal = false;
      this.$router.push({
        name: "elevate"
      });
    },
    closeMessageModal: function closeMessageModal() {
      this.showModal = false;
    }
  }
};
import { ref, computed, provide } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import Text from "@/consts/text";
import { mapState } from "vuex";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import MessageModal from "../common/MessageModal.vue";
import { getAbsentAlert, assignAbsentBudge, formatPhoneNumber } from "@/services/common";
import { useStore } from "vue2-helpers/vuex"; // モジュール読み込み

import LatestAbsenceInfo from "@/components/dashboard/LatestAbsenceInfo";
import LatestAttendanceCounter from "@/components/dashboard/LatestAttendanceCounter";
import AllClassAbsenceCounter from "@/components/dashboard/AllClassAbsenceCounter";
import GradeTable from "@/components/dashboard/GradeTable"; // import LatestTemperature from "@/components/dashboard/LatestTemperature.vue";

import LatestSchoolForum from "@/components/dashboard/LatestSchoolForum.vue";
import RowItem from "../RowItem";
import LatestGovernmentForum from "@/components/dashboard/LatestGovernmentForum.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var store = useStore();
    var me = computed(function () {
      return store.state.me;
    });
    var classrooms = computed(function () {
      return store.state.classrooms;
    });
    var phoneAttendance = computed(function () {
      return formatPhoneNumber(store.state.school.phone_attendance);
    });

    var _storeToRefs = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs.schoolPlan;

    var attendanceMode = ref("counter");
    provide("attendanceMode", attendanceMode);
    expose({
      me: me,
      classrooms: classrooms
    });
    return {
      __sfc: true,
      store: store,
      me: me,
      classrooms: classrooms,
      phoneAttendance: phoneAttendance,
      schoolPlan: schoolPlan,
      attendanceMode: attendanceMode,
      MessageModal: MessageModal,
      LatestAbsenceInfo: LatestAbsenceInfo,
      LatestAttendanceCounter: LatestAttendanceCounter,
      AllClassAbsenceCounter: AllClassAbsenceCounter,
      GradeTable: GradeTable,
      LatestSchoolForum: LatestSchoolForum,
      RowItem: RowItem,
      LatestGovernmentForum: LatestGovernmentForum
    };
  }
});